import { CircularLoaderIcon } from '@navi/web-ui/lib/icons';
import StepsButton from '../StepsButton';
import { Typography } from '@navi/web-ui/lib/primitives';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';

interface IApprovalStep {
  approvedMockId: string;
  onConfirm: () => void;
  handleCloseModal: () => void;
  isLoading: boolean;
}
const ApprovalStep = (props: IApprovalStep) => {
  const { approvedMockId, onConfirm, handleCloseModal, isLoading } = props;
  const updateMockRunStatusLoading = useSelector(
    (state: RootState) => state.fieldAllocation?.updateMockRunStatusLoading
  );

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-[164px]">
        <CircularLoaderIcon size="md" />
      </div>
    );
  }

  return (
    <div>
      {approvedMockId ? (
        <div className="flex justify-between items-center mb-8">
          <Typography variant="h4" color="var(--navi-color-gray-c2)">
            Do you want to proceed and override the approval?
          </Typography>
        </div>
      ) : null}
      <StepsButton
        onCancel={handleCloseModal}
        onAction={onConfirm}
        actionText="Confirm"
        disabled={false}
        isLoading={updateMockRunStatusLoading}
      />
    </div>
  );
};

export default ApprovalStep;
